import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import Grid from "@material-ui/core/Grid";
import Chip from "@material-ui/core/Chip";

import CancelIcon from "@material-ui/icons/Cancel";
import { useStyles } from "./ClassDetail.css";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

class ClassDetail extends Component {
  render() {
    const { classes, detailData, handleCancelDetail } = this.props;
    return (
      <div className={classes.root}>
        <div className={classes.title}>
          <div style={{ fontSize: 18, flexGrow: 1 }}>Details</div>
          <div className={classes.iconStyle}>
            <CancelIcon onClick={handleCancelDetail} />
          </div>
        </div>
        <div className={classes.body}>
          <ListItem divider>
            <div style={{ flexGrow: 1 }}>Class Name</div>
            <div>{detailData.className}</div>
          </ListItem>
          <ListItem divider>
            <div style={{ flexGrow: 1 }}>Faculty</div>
            <div>{detailData.faculty ? detailData.faculty : "Not Entered"}</div>
          </ListItem>
          <ListItem divider>
            <div style={{ flexGrow: 1 }}>Group</div>
            <div>{detailData.group ? detailData.group : "Not Entered"}</div>
          </ListItem>
          <ListItem divider>
            <div style={{ flexGrow: 1 }}>Sections</div>
            <div>{detailData.section.length}</div>
          </ListItem>
          <ListItem divider>
            <Grid
              container
              spacing={3}
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {detailData.section.map((section, index) => (
                <Grid
                  item
                  xs={1}
                  sm={1}
                  md={1}
                  xl={1}
                  lg={1}
                  key={index}
                  style={{ marginRight: 20 }}
                >
                  {section.name}
                </Grid>
              ))}
            </Grid>
          </ListItem>

          <ListItem divider>
            <div style={{ flexGrow: 1 }}>Subjects</div>
            <div>{detailData.subjects.length}</div>
          </ListItem>
          <ListItem divider>
            <Grid
              container
              spacing={3}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {detailData.subjects.map((subject, index) => (
                <Grid item key={index}>
                  <Chip label={subject.name} />
                </Grid>
              ))}
            </Grid>
          </ListItem>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(withRouter(ClassDetail)));
